import { createAssetFactory } from '@exodus/ethereum-api'
import assetsList from '@exodus/mantlesepolia-meta'

const createAsset = createAssetFactory({
  assetsList,
  feeDataConfig: {
    gasPrice: '0.02 Gwei',
    baseFeePerGas: '0.02 Gwei',
    tipGasPrice: '0 Gwei',
    max: '1 Gwei',
    min: '0.02 Gwei', // https://docs-v2.mantle.xyz/devs/concepts/tx-fee/overviews#fee-optimization
    fuelThreshold: '1500000 Gwei',
    eip1559Enabled: true, // https://www.mantle.xyz/blog/announcements/mantle-completes-mainnet-v2-tectonic-upgrade
  },
  erc20FuelBuffer: 1.1, // 10% more than the required fee
  serverUrl: 'https://mantle-sepolia-qn.a.exodus.io/',
  confirmationsNumber: 30,
  monitorType: 'no-history',
  isTestnet: true,
  customTokens: false,
  forceGasLimitEstimation: true,
})

const assetPlugin = { createAsset }

export default assetPlugin
